// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l-selected-menu {
    background: black;
}
li.l-linked-menu.l-menuitem > a, li.l-menuitem.active-menuitem > a {
    color: #0388e5;
}
ul li.l-menuitem a {
    color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/AppMenu.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB","sourcesContent":[".l-selected-menu {\n    background: black;\n}\nli.l-linked-menu.l-menuitem > a, li.l-menuitem.active-menuitem > a {\n    color: #0388e5;\n}\nul li.l-menuitem a {\n    color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
